import { useLocalStorage } from 'react-use';

import { diff, getDate } from '../../services/timeService';
import { unitOfTime } from '../../services/timeService/types';

const MAX_RECENT_VALUES = 10;

interface StoredEntry {
  value: string;
  savedAt: number;
}

export function useRecentLoginValues(storageKey: string) {
  const [stored, setStoredValues] = useLocalStorage<StoredEntry[]>(storageKey, []);

  const freshEntries = (Array.isArray(stored) ? stored : []).filter(
    (e): e is StoredEntry =>
      !!e &&
      typeof e.value === 'string' &&
      e.value.length > 0 &&
      typeof e.savedAt === 'number' &&
      diff(getDate(e.savedAt), unitOfTime.weeks) < 2,
  );

  const saveValue = (value: string) => {
    if (!value.trim()) return;
    setStoredValues(
      [
        { value: value.trim(), savedAt: getDate().valueOf() },
        ...freshEntries.filter((e) => e.value.toLowerCase() !== value.trim().toLowerCase()),
      ].slice(0, MAX_RECENT_VALUES),
    );
  };

  return { recentValues: freshEntries.map((e) => e.value), saveValue };
}
